import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft
} from '@fortawesome/pro-solid-svg-icons';

import { saveRequest } from './store/actions/form';
import { getVerificationState } from './store/verification_selectors';
import { canSave } from './store/selectors';
import { VERIFICATION_STATE } from './constants';
import Verification from './mapping/verification';
import NewImportBackToUploadModal from './new_import_back_to_upload_modal';
import NewImportCancelModal from './new_import_cancel_modal';

export function NewImportVerification({
  canSave,
  verification,
  onSubmit
}) {
  const history = useHistory();
  const [showBackToUploadModal, setShowBackToUploadModal] = useState(false);

  const handleSubmit = () => {
    onSubmit(true)
      .then((response) => {
        if (response) {
          history.push(`/${response.id}/mapping`);
        }
      });
  };

  const handleBackToUpload = () => {
    setShowBackToUploadModal(true);
  };

  const renderDescription = () => {
    return (
      <div className="container" name="description">
        <div className="mb-4">
          <h3 className="semi-bold mb-4">Import Upload - Verification</h3>
          <p className="mt-4">
            Your uploaded data is currently being verified. During verification,
            the imports system will check your data to ensure that
            it can be successfully imported based on what the system accepts.
            If you would like to recieve an email when the verification process is complete, check the box below.
          </p>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      {renderDescription()}
      <div className="container mb-4">
        <a className="js-import-tab" onClick={handleBackToUpload}>
          <FontAwesomeIcon icon={faChevronLeft} />
          <span className="ml-2">Back to upload form</span>
        </a>
      </div>
      <Verification />
      <div className="container mb-4 p-0">
        <NewImportCancelModal />
        {
          verification.state === VERIFICATION_STATE.SUCCESS && (
            <button className="btn btn-save ml-2" disabled={!canSave} onClick={handleSubmit}>
              Save &amp; Continue
            </button>
          )
        }
      </div>
      <NewImportBackToUploadModal
        shown={showBackToUploadModal}
        onClose={setShowBackToUploadModal}
      />
    </React.Fragment>
  );
}

NewImportVerification.propTypes = {
  canSave: PropTypes.bool.isRequired,
  verification: PropTypes.shape({
    state: PropTypes.string.isRequired,
    result: PropTypes.object,
    errors: PropTypes.array
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  canSave: canSave(state),
  verification: getVerificationState(state)
});

const mapDispatchToProps = {
  onSubmit: saveRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(NewImportVerification);
